import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../../../hooks/hooks";
import { jobs } from "../../../../../redux/jobs/action";
import { selectListItems } from "../../../../../redux/library/selector";
import PageLoader from "../../../../../components/PageLoader";
import { selectJobsListItems } from "../../../../../redux/jobs/selector";
import useWindowDimensions from "../../../../../hooks/useWindowsDimensions";
import _ from "lodash";
import Table from "../../../../../common/components/table-manager/v1.1/table";
import { agentStatus } from "../../../../../redux/orderstatus/action";



const ManagementJobs = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const { height, width } = useWindowDimensions();
  const [pageData, setPageData] = useState(1)
  const libraryData = useSelector(selectListItems)
  const [pageSize, setPageSize] = useState(10);
  const itemsData = useSelector(selectJobsListItems)
  const [
    columnDefs,
    setColumnDefs
  ] = useState({});

  const handleEdit = (data: any) => {
    navigate(`${data?.MobilityJobId}`)
  }

  const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer(params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },
      { field: 'OrderId', headerName: 'OrderId' },
      { field: 'RAPAgentName', headerName: 'RAPAgent Name' },
      { field: 'RAPName', headerName: 'RAP Name' },
      { field: 'IsRTOMobilityJob', headerName: 'RTO Mobility JOB', cellRenderer: 'yesNoRenderer' },
      {field: `MobilityJobStatusId`, headerName: 'Jobstatus', cellRenderer: 'libraryRendererComponent',
      cellRendererParams: { library: libraryData?.result?.MobilityJobStatus }, isMobilityJobEditable: true, isRowColorDecider: true,
       },
      { field: 'IsQCTask', headerName: 'QC Task', cellRenderer: 'yesNoRenderer' },
      { field: 'PickupInfo.location', headerName: 'From Address', isAddressFormat: true },
      { field: 'DeliveryInfo.location', headerName: 'To Address', isAddressFormat: true },
      { field: 'IsRTOQCEnabled', headerName: 'Is RTO QC Enabled', cellRenderer: 'yesNoRenderer' },
      { field: 'MobilityJobNotes', headerName: 'Mobility Job Notes', },
      { field: 'CreatedOnUtc', headerName: 'Created On', isDateValueFormat: true }
    ]);
  }

  const fetchJobs = () => {
    dispatch(jobs.list({
      url: `https://impapi.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/smart-booking/jobs/fetch`, entity: 'jobs', jsonData: {
        "Context": {},
        "Records": [{}],
        "Pagination": {
          "PageNumber": pageData,
          "PageSize": pageSize,
          "SortField": " MobilityJobId",
          "SortOrder": "desc",
        }
      }
    }))
  }

  useEffect(() => {
    createColumnDefs()
    fetchJobs()

  }, [pageData, pageSize])

  const handleDelete = async (data: any) => {
    await dispatch(jobs.delete({
      url: `https://impapi.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/sales/orders/delete`,
      entity: 'orders',
      jsonData: {
        Records: [
          {
            Id: data?.Id


          }
        ]
      }
    }))
    await fetchJobs()
  }
  
  const handleMobilityStatusClick = async (event: any, rowData: any, code: any) => {
    if (event == -10) {
      await dispatch(agentStatus.resetAction({ actionType: 'update' }))
      await dispatch(agentStatus.update({
        url: `https://impapi.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/smart-booking/jobs/status`,
        entity: 'jobStatus',
        jsonData:
        {
          "Context": {},
          "Records": [
            {
              "Id": rowData?.MobilityJobId,
               "MobilityOrderId": rowData?.OrderId,
              "MobilityJobStatusId": event,
              "CancelReasonCode": code,
            }
          ]
        }
      })).then(() => {
        fetchJobs()
      });
    } else {
      await dispatch(agentStatus.resetAction({ actionType: 'update' }))
      await dispatch(agentStatus.update({
        url: `https://impapi.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/smart-booking/jobs/status`,
        entity: 'jobStatus',
        jsonData:
        {
          "Context": {},
          "Records": [
            {
              "Id": rowData?.MobilityJobId,
               "MobilityOrderId":  rowData?.OrderId,
              "MobilityJobStatusId": event,
            }
          ]
        }
      })).then(() => {
        fetchJobs()
      });
    }

  }

  return (
    <>
      {itemsData?.isLoading ? <PageLoader />
        :
        <Table
          checkboxConfig={{
            allowMultiSelect: true,
            defaultSelectedIds: [],
            isDisabled: false,
            keyColumn: 'Id',
          }}
          enableFilter={true}
          columnData={columnDefs}
          rowData={itemsData?.result?.items}
          setPageData={setPageData}
          setPageSize={setPageSize}
          onMobilityStatusClick={handleMobilityStatusClick}
          paginationData={itemsData?.result?.pagination}
          onEdit={handleEdit}
          onDelete={handleDelete}
          headingName="Job" />
      }
    </>

  );
};

export default ManagementJobs;
